import { motion } from "framer-motion";
import { Star, ExternalLink } from "lucide-react";
import { useT } from "@/i18n";
import { PLATFORMS, WEB_TEXT } from "@/components/webdev/content";

export default function PlatformCards() {
  const { lang } = useT();
  const tx = WEB_TEXT[lang];
  return (
    <div>
      <h3 className="font-fredoka text-xl sm:text-2xl font-bold text-blue-950">{tx.platforms}</h3>
      <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {PLATFORMS.map((p, i) => {
          const Icon = p.icon;
          return (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06 }}
              className={`bg-gradient-to-br ${p.color} rounded-3xl border-4 border-white p-3 shadow-lg flex flex-col`}
              data-testid={`web-platform-${p.id}`}
            >
              <div className="flex items-center gap-3 p-2">
                <div className="bg-white/90 rounded-2xl p-2.5"><Icon className="w-7 h-7 text-blue-950" /></div>
                <div>
                  <p className="font-fredoka text-xl font-bold text-white bubble-text-sm">{p.name}</p>
                  <div className="flex">
                    {[1, 2, 3].map((n) => (
                      <Star key={n} className={`w-4 h-4 ${n <= p.level ? "text-yellow-200 fill-yellow-200" : "text-white/40"}`} />
                    ))}
                  </div>
                </div>
              </div>
              <div className="bg-white/90 rounded-2xl p-3 mt-1 flex-1 flex flex-col">
                <p className="text-sm text-blue-950 font-semibold flex-1">{p[lang]}</p>
                {p.free && <span className="mt-2 self-start bg-lime-200 text-green-800 text-xs font-bold rounded-full px-2 py-0.5">{tx.free}</span>}
                <a href={p.url} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex items-center gap-1 text-sm font-bold text-blue-700 hover:underline" data-testid={`web-platform-link-${p.id}`}>
                  {tx.open} <ExternalLink className="w-4 h-4" />
                </a>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
